import React from 'react';
import { useMediaQuery } from '../hooks/useMediaQuery';

// Функция-генератор теперь принимает pageNeighbours
const generatePagination = (currentPage, totalPages, pageNeighbours) => {
  const pages = [];
  const totalNumbers = (pageNeighbours * 2) + 2;
  const totalBlocks = totalNumbers + 2;

  if (totalPages > totalBlocks) {
    const startPage = Math.max(2, currentPage - pageNeighbours);
    const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
    let pagesToShow = Array.from({ length: (endPage - startPage) + 1 }, (_, i) => startPage + i);

    const hasLeftSpill = startPage > 2;
    const hasRightSpill = (totalPages - endPage) > 1;
    const spillOffset = totalNumbers - (pagesToShow.length + 1);

    switch (true) {
      case (hasLeftSpill && !hasRightSpill): {
        const extraPages = Array.from({ length: spillOffset + 1 }, (_, i) => startPage - i - 1);
        pagesToShow = ["...", ...extraPages.reverse(), ...pagesToShow];
        break;
      }
      case (!hasLeftSpill && hasRightSpill): {
        const extraPages = Array.from({ length: spillOffset + 1 }, (_, i) => endPage + i + 1);
        pagesToShow = [...pagesToShow, ...extraPages, "..."];
        break;
      }
      case (hasLeftSpill && hasRightSpill):
      default: {
        pagesToShow = ["...", ...pagesToShow, "..."];
        break;
      }
    }
    return [1, ...pagesToShow, totalPages];
  }
  return Array.from({ length: totalPages }, (_, i) => i + 1);
};


export default function Pagination({ currentPage, totalPages, onPageChange }) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const pageNeighbours = isMobile ? 0 : 1;
  
  if (totalPages <= 1) return null;

  const pagesToRender = generatePagination(currentPage, totalPages, pageNeighbours);

  return (
    <div className="pagination">
      <button 
        className="page-button arrow" 
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        &larr;
      </button>

      {pagesToRender.map((page, index) => {
        if (page === "...") {
          return <span key={`ellipsis-${index}`} className="page-ellipsis">...</span>;
        }
        
        return (
          <button
            key={page}
            className={`page-button ${currentPage === page ? 'active' : ''}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        );
      })}

      <button 
        className="page-button arrow" 
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        &rarr;
      </button>
    </div>
  );
}